import Script from 'next/script'
import { MessageCircle } from 'react-feather'
import getConfig from 'next/config'
import { useSessionContext } from '@contexts/session'

const { publicRuntimeConfig } = getConfig()

const InkeepWidget = () => {
  const { id, email, name } = useSessionContext()
  return (
    <>
      <div id="inkeepModal">
        <button
          id="chat-button"
          className="py-1 px-3 text align-middle font-600 text-white focus:outline-none rounded-2xl flex bg-orange shadow-md hover:bg-orange-500 hover:shadow-lg duration-300"
          aria-label="Ask AI"
        >
          <MessageCircle className="w-5 mr-1" /> <span>Ask AI</span>
        </button>
      </div>
      <Script
        type="module"
        src="https://cdn.jsdelivr.net/npm/@inkeep/cxkit-js@0.5/dist/embed.js"
        strategy="afterInteractive"
      />
      <Script
        id="inkeep-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
                    (function() {
                      function handleOpenChange(newOpen) {
                        window.inkeepWidget && window.inkeepWidget.update({ modalSettings: { isOpen: newOpen } });
                      }
                      function initInkeep() {
                        if (!window.Inkeep) {
                          setTimeout(initInkeep, 200);
                          return;
                        }
                        const config = {
                          baseSettings: {
                            apiKey: "${publicRuntimeConfig.NEXT_PUBLIC_INKEEP_API_KEY}",
                            primaryBrandColor: "#ff5a43",
                            organizationDisplayName: "Codingal",
                            userProperties: {
                              id: "${id}",
                              email: "${email}",
                              name: "${name}",
                            }
                          },
                          searchSettings: {},
                          aiChatSettings: {
                            exampleQuestions: [
                              "How to take renewal PTM?",
                              "How to change curriculum?",                            ]
                          },
                          modalSettings: {
                            onOpenChange: handleOpenChange
                          }
                        };
                        window.inkeepWidget = window.Inkeep.ModalChat(config);
                        var chatBtn = document.getElementById("chat-button");
                        if (chatBtn) {
                          chatBtn.addEventListener("click", function() {
                            window.inkeepWidget.update({ modalSettings: { isOpen: true } });
                          });
                        }
                      }
                      initInkeep();
                    })();
                  `,
        }}
      />
    </>
  )
}
export default InkeepWidget
